export default "https://housescan.app.solease.nl/static/media/glass_insulation.91a8bfd3.svg";